const getters = {
  getReminders: (state) => state.reminders,
  getCheckNotificationInterval: (state) => state.checkNotificationInterval,
};

export default getters;
